// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Product {
    background-color: #303030;
    min-height: 100vh;
    margin-top: 80px;
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.Product h1 {
    color: white;
    font-size: 1.5rem;
    text-align: center;
    margin: 40px auto;
    font-family: 'GlitchGoblin', sans-serif;
}

.product-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    max-width: 1500px;
    margin: 0 auto;
    gap: 24px;
}

.product-card {
    flex: 0 0 170px;
    background-color: white;
    border-radius: 16px;
    min-height: 25px;
    box-sizing: border-box;
    display: flex; 
    flex-direction: column;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15);
}

.image-wrapper {
    aspect-ratio: 1 / 1;
    width: 100%;
    overflow: hidden;
    padding: 5.5px;
    box-sizing: border-box;
    background-color: #cde5ff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.product-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
}

.product-details {
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.product-details h2 {
    font-size: 0.9rem;
    margin: 0;
    color: #007bff;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.description-container {
    margin: 5px 0 10px 0;
    text-align: left;
}

.product-description {
    font-size: 13px;
    color: #666;
    line-height: 1.3;
    margin: 0;
    overflow-wrap: break-word;
    min-height: 50px;
    align-content: center;
}

.product-details p {
    margin: 0px;
}

.toggle-description-button {
    background: none;
    border: none;
    color: #1890ff;
    cursor: pointer;
    padding: 0;
    font-size: 0.75rem;
    text-align: left;
    margin-top: 5px;
    display: block;
    transition: color 0.2s;
}

.toggle-description-button:hover {
    text-decoration: underline;
}

.price-add {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
}

.price {
    font-weight: 500;
    font-size: 0.7rem;
    color: #333;
}

.add-to-cart {
    background-color: #007bff;
    border: none;
    border-radius: 50%;
    color: white;
    width: 30px;
    height: 30px;
    font-size: 1.4rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    transition: background-color 0.3s ease;
    flex-shrink: 0;
}

.product-category {
    padding: 20px 0;
}

.category-title {
    font-size: 1.5rem;
    margin: 2rem 0 1.2rem;
    padding-left: 20px;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #007bff;
    color: #ffffff;
    position: relative;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.category-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 6px;
    height: 100%;
    background-color: #007bff;
    border-radius: 4px;
}

.see-more-wrapper {
    text-align: center;
    margin-top: 1rem;
}

.see-more-button {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    font-size: 0.9rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.category-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 1rem auto 2rem;
    justify-content: center;
}

.category-button {
    padding: 8px 16px;
    background-color: #424242;
    color: white;
    border: 2px solid #007bff;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.3s ease;
    width: 250px;
}

.category-button:hover,
.category-button.active {
    background-color: #007bff;
    color: white;
}

.duration-select {
    width: 100%;
    padding: 4px 8px;
    margin: 10px 0;
    font-family: 'Segoe UI', sans-serif;
    color: #333;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 6px;
    appearance: none;
    outline: none;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 16px 16px;
    padding-right: 30px;
}

.duration-select:focus {
    border-color: #007bff;
    background-color: #f0f0f0;
}

.in-cart-badge {
    display: inline-block;
    background: #f0ad4e;
    color: white;
    font-size: 0.75rem;
    padding: 2px 6px;
    border-radius: 4px;
    margin-right: 0.5rem;
}

.add-btn-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 8px;
}

.stock-text {
    font-size: 0.85rem;
    color: #777;
    margin-top: 0.4rem;
}

.add-to-cart[disabled] {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    opacity: 0.5;
}

/* ========================================== */
/* BASE OVERLAY FOCUS STYLES (DESKTOP FIRST)  */
/* ========================================== */
.product-focus-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.2s ease-out;
    padding: 15px; /* Elak inframe rapat dinding skrin di tablet */
    box-sizing: border-box;
}

.product-focus-inframe {
    background: #3e3e3e;
    color: #ffffff;
    width: 100%;
    max-width: 800px;
    max-height: 90vh; /* Hadkan tinggi modal kalau description panjang */
    overflow-y: auto; /* Boleh skrol kalau isi terlampau panjang */
    border-radius: 12px;
    padding: 30px;
    position: relative;
    box-shadow: 0px 10px 30px rgba(0,0,0,0.5);
    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

.close-focus-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    background: none;
    border: none;
    color: #aaa;
    font-size: 32px;
    cursor: pointer;
    transition: color 0.2s;
    z-index: 10;
}

.close-focus-btn:hover {
    color: #fff;
}

.focus-content-layout {
    display: flex;
    gap: 30px;
    margin-top: 15px;
}

.focus-image-section {
    flex: 1 1;
    max-width: 40%;
}

.focus-image-section img {
    width: 100%;
    border-radius: 8px;
    object-fit: cover;
    max-height: 300px;
}

.focus-details-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.focus-details-section h2 {
    text-align: left; /* Tukar ke left supaya serasi dengan teks lain */
    color: #007bff;
    margin: 0 0 15px 0;
    font-size: 1.5rem;
}

.focus-full-description {
    font-size: 14px;
    color: #ccc;
    line-height: 1.6;
    margin-bottom: 20px;
}

.focus-action-box {
    background: #ffffff;
    padding: 15px;
    border-radius: 8px;
    color: #333;
}

.focus-action-box label {
    font-weight: bold;
    display: block;
    margin-bottom: 5px;
}

.focus-price-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    gap: 10px;
}

.focus-price {
    font-size: 22px;
    font-weight: bold;
    color: #333;
}

.focus-add-btn {
    background: #007bff;
    color: #ffffff;
    border: none;
    padding: 10px 20px;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.2s;
}

.focus-add-btn:hover:not(:disabled) {
    background-color: #0056b3;
}

.focus-add-btn:disabled {
    background: #ccc;
    color: #888888;
    cursor: not-allowed;
}

/* ========================================== */
/* 🔹 MOBILE RESPONSIVE MEDIA QUERY (768px)  */
/* ========================================== */
@media (max-width: 768px) {
    .Product {
        padding: 20px 10px;
    }

    .Product h1 {
        margin: 0 auto 20px auto;
        font-size: 23px;
    }

    .product-list {
        gap: 15px;
        width: 100%;
    }

    .product-card {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc(50% - 8px); /* Dua kad sebaris yang ngam */
        max-width: none;
    }

    .product-details h2 {
        font-size: 14px; /* Kecilkan sikit biar tak terpotong teruk dekat fon */
    }

    .price {
        font-size: 13px;
    }

    .duration-select {
        font-size: 13px;
        padding: 6px;
    }

    .add-to-cart {
        width: 32px;
        height: 32px;
        font-size: 1.2rem;
    }

    /* 🛑 PERBAIKAN INFRAME OVERLAY KAT MOBILE 🛑 */
    .product-focus-inframe {
        width: 100%;
        max-width: 100%;
        padding: 20px;
        margin: 10px;
    }

    .focus-content-layout {
        flex-direction: column; /* Gambar naik atas, detail turun bawah */
        gap: 15px;
    }

    .focus-image-section {
        max-width: 100%;
        text-align: center;
    }

    .focus-image-section img {
        max-height: 200px; /* Jangan bagi gambar makan ruang skrin fon */
        width: auto;
        max-width: 100%;
    }

    .focus-details-section h2 {
        font-size: 1.2rem;
        text-align: center;
        margin-top: 5px;
    }

    .focus-full-description {
        font-size: 13px;
        text-align: center;
        margin-bottom: 15px;
    }
    
    .focus-price-row {
        flex-direction: column; /* Harga atas, butang bawah dekat fon */
        gap: 12px;
        text-align: center;
    }
    
    .focus-add-btn {
        width: 100%; /* Butang jadi lebar penuh senang user nak tap */
    }
}

/* Animations */
@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
@keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/Product.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,4DAA4D;AAChE;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mCAAmC;IACnC,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8DAA8D;IAC9D,eAAe;IACf,yDAAkL;IAClL,4BAA4B;IAC5B,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,aAAa,EAAE,+CAA+C;IAC9D,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB,EAAE,kDAAkD;IACpE,gBAAgB,EAAE,4CAA4C;IAC9D,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,qDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB,EAAE,iDAAiD;IACnE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C,8CAA8C;AAC9C,+CAA+C;AAC/C;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;QACxB,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,YAAyB;QAAzB,cAAyB;QAAzB,2BAAyB,EAAE,8BAA8B;QACzD,eAAe;IACnB;;IAEA;QACI,eAAe,EAAE,sDAAsD;IAC3E;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA,+CAA+C;IAC/C;QACI,WAAW;QACX,eAAe;QACf,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,sBAAsB,EAAE,yCAAyC;QACjE,SAAS;IACb;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB,EAAE,6CAA6C;QAChE,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB,EAAE,uCAAuC;QAC/D,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW,EAAE,gDAAgD;IACjE;AACJ;;AAEA,eAAe;AACf;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;AACA;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC/C","sourcesContent":[".Product {\n    background-color: #303030;\n    min-height: 100vh;\n    margin-top: 80px;\n    padding: 20px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.Product h1 {\n    color: white;\n    font-size: 1.5rem;\n    text-align: center;\n    margin: 40px auto;\n    font-family: 'GlitchGoblin', sans-serif;\n}\n\n.product-list {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    max-width: 1500px;\n    margin: 0 auto;\n    gap: 24px;\n}\n\n.product-card {\n    flex: 0 0 170px;\n    background-color: white;\n    border-radius: 16px;\n    min-height: 25px;\n    box-sizing: border-box;\n    display: flex; \n    flex-direction: column;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.product-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15);\n}\n\n.image-wrapper {\n    aspect-ratio: 1 / 1;\n    width: 100%;\n    overflow: hidden;\n    padding: 5.5px;\n    box-sizing: border-box;\n    background-color: #cde5ff;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n}\n\n.product-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 16px;\n}\n\n.product-details {\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.product-details h2 {\n    font-size: 0.9rem;\n    margin: 0;\n    color: #007bff;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.description-container {\n    margin: 5px 0 10px 0;\n    text-align: left;\n}\n\n.product-description {\n    font-size: 13px;\n    color: #666;\n    line-height: 1.3;\n    margin: 0;\n    overflow-wrap: break-word;\n    min-height: 50px;\n    align-content: center;\n}\n\n.product-details p {\n    margin: 0px;\n}\n\n.toggle-description-button {\n    background: none;\n    border: none;\n    color: #1890ff;\n    cursor: pointer;\n    padding: 0;\n    font-size: 0.75rem;\n    text-align: left;\n    margin-top: 5px;\n    display: block;\n    transition: color 0.2s;\n}\n\n.toggle-description-button:hover {\n    text-decoration: underline;\n}\n\n.price-add {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n}\n\n.price {\n    font-weight: 500;\n    font-size: 0.7rem;\n    color: #333;\n}\n\n.add-to-cart {\n    background-color: #007bff;\n    border: none;\n    border-radius: 50%;\n    color: white;\n    width: 30px;\n    height: 30px;\n    font-size: 1.4rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    transition: background-color 0.3s ease;\n    flex-shrink: 0;\n}\n\n.product-category {\n    padding: 20px 0;\n}\n\n.category-title {\n    font-size: 1.5rem;\n    margin: 2rem 0 1.2rem;\n    padding-left: 20px;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid #007bff;\n    color: #ffffff;\n    position: relative;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.category-title::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 6px;\n    height: 100%;\n    background-color: #007bff;\n    border-radius: 4px;\n}\n\n.see-more-wrapper {\n    text-align: center;\n    margin-top: 1rem;\n}\n\n.see-more-button {\n    padding: 8px 16px;\n    background-color: #007bff;\n    color: white;\n    font-size: 0.9rem;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.category-bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin: 1rem auto 2rem;\n    justify-content: center;\n}\n\n.category-button {\n    padding: 8px 16px;\n    background-color: #424242;\n    color: white;\n    border: 2px solid #007bff;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: all 0.3s ease;\n    width: 250px;\n}\n\n.category-button:hover,\n.category-button.active {\n    background-color: #007bff;\n    color: white;\n}\n\n.duration-select {\n    width: 100%;\n    padding: 4px 8px;\n    margin: 10px 0;\n    font-family: 'Segoe UI', sans-serif;\n    color: #333;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    appearance: none;\n    outline: none;\n    transition: border-color 0.2s ease, background-color 0.2s ease;\n    cursor: pointer;\n    background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 16px 16px;\n    padding-right: 30px;\n}\n\n.duration-select:focus {\n    border-color: #007bff;\n    background-color: #f0f0f0;\n}\n\n.in-cart-badge {\n    display: inline-block;\n    background: #f0ad4e;\n    color: white;\n    font-size: 0.75rem;\n    padding: 2px 6px;\n    border-radius: 4px;\n    margin-right: 0.5rem;\n}\n\n.add-btn-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 8px;\n}\n\n.stock-text {\n    font-size: 0.85rem;\n    color: #777;\n    margin-top: 0.4rem;\n}\n\n.add-to-cart[disabled] {\n    background-color: #ccc;\n    color: #666;\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n/* ========================================== */\n/* BASE OVERLAY FOCUS STYLES (DESKTOP FIRST)  */\n/* ========================================== */\n.product-focus-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.75);\n    backdrop-filter: blur(5px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    animation: fadeIn 0.2s ease-out;\n    padding: 15px; /* Elak inframe rapat dinding skrin di tablet */\n    box-sizing: border-box;\n}\n\n.product-focus-inframe {\n    background: #3e3e3e;\n    color: #ffffff;\n    width: 100%;\n    max-width: 800px;\n    max-height: 90vh; /* Hadkan tinggi modal kalau description panjang */\n    overflow-y: auto; /* Boleh skrol kalau isi terlampau panjang */\n    border-radius: 12px;\n    padding: 30px;\n    position: relative;\n    box-shadow: 0px 10px 30px rgba(0,0,0,0.5);\n    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\n.close-focus-btn {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    background: none;\n    border: none;\n    color: #aaa;\n    font-size: 32px;\n    cursor: pointer;\n    transition: color 0.2s;\n    z-index: 10;\n}\n\n.close-focus-btn:hover {\n    color: #fff;\n}\n\n.focus-content-layout {\n    display: flex;\n    gap: 30px;\n    margin-top: 15px;\n}\n\n.focus-image-section {\n    flex: 1;\n    max-width: 40%;\n}\n\n.focus-image-section img {\n    width: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n    max-height: 300px;\n}\n\n.focus-details-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.focus-details-section h2 {\n    text-align: left; /* Tukar ke left supaya serasi dengan teks lain */\n    color: #007bff;\n    margin: 0 0 15px 0;\n    font-size: 1.5rem;\n}\n\n.focus-full-description {\n    font-size: 14px;\n    color: #ccc;\n    line-height: 1.6;\n    margin-bottom: 20px;\n}\n\n.focus-action-box {\n    background: #ffffff;\n    padding: 15px;\n    border-radius: 8px;\n    color: #333;\n}\n\n.focus-action-box label {\n    font-weight: bold;\n    display: block;\n    margin-bottom: 5px;\n}\n\n.focus-price-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 15px;\n    gap: 10px;\n}\n\n.focus-price {\n    font-size: 22px;\n    font-weight: bold;\n    color: #333;\n}\n\n.focus-add-btn {\n    background: #007bff;\n    color: #ffffff;\n    border: none;\n    padding: 10px 20px;\n    font-weight: bold;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.focus-add-btn:hover:not(:disabled) {\n    background-color: #0056b3;\n}\n\n.focus-add-btn:disabled {\n    background: #ccc;\n    color: #888888;\n    cursor: not-allowed;\n}\n\n/* ========================================== */\n/* 🔹 MOBILE RESPONSIVE MEDIA QUERY (768px)  */\n/* ========================================== */\n@media (max-width: 768px) {\n    .Product {\n        padding: 20px 10px;\n    }\n\n    .Product h1 {\n        margin: 0 auto 20px auto;\n        font-size: 23px;\n    }\n\n    .product-list {\n        gap: 15px;\n        width: 100%;\n    }\n\n    .product-card {\n        flex: 0 0 calc(50% - 8px); /* Dua kad sebaris yang ngam */\n        max-width: none;\n    }\n\n    .product-details h2 {\n        font-size: 14px; /* Kecilkan sikit biar tak terpotong teruk dekat fon */\n    }\n\n    .price {\n        font-size: 13px;\n    }\n\n    .duration-select {\n        font-size: 13px;\n        padding: 6px;\n    }\n\n    .add-to-cart {\n        width: 32px;\n        height: 32px;\n        font-size: 1.2rem;\n    }\n\n    /* 🛑 PERBAIKAN INFRAME OVERLAY KAT MOBILE 🛑 */\n    .product-focus-inframe {\n        width: 100%;\n        max-width: 100%;\n        padding: 20px;\n        margin: 10px;\n    }\n\n    .focus-content-layout {\n        flex-direction: column; /* Gambar naik atas, detail turun bawah */\n        gap: 15px;\n    }\n\n    .focus-image-section {\n        max-width: 100%;\n        text-align: center;\n    }\n\n    .focus-image-section img {\n        max-height: 200px; /* Jangan bagi gambar makan ruang skrin fon */\n        width: auto;\n        max-width: 100%;\n    }\n\n    .focus-details-section h2 {\n        font-size: 1.2rem;\n        text-align: center;\n        margin-top: 5px;\n    }\n\n    .focus-full-description {\n        font-size: 13px;\n        text-align: center;\n        margin-bottom: 15px;\n    }\n    \n    .focus-price-row {\n        flex-direction: column; /* Harga atas, butang bawah dekat fon */\n        gap: 12px;\n        text-align: center;\n    }\n    \n    .focus-add-btn {\n        width: 100%; /* Butang jadi lebar penuh senang user nak tap */\n    }\n}\n\n/* Animations */\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n@keyframes slideUp {\n    from { transform: translateY(20px); opacity: 0; }\n    to { transform: translateY(0); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
